import JassEnum from './enum';

/**
 * type racepreference
 */
export default class JassRacePreference extends JassEnum {}
